import z from 'zod';

export const ZodIssueNewTreeMeta = z.object({
  blockId: z.uuid(),
  volume: z.number().min(0.001),
  accountId: z.uuid(),
});

export type IssueNewTreeMeta = z.infer<typeof ZodIssueNewTreeMeta>;
